import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartPie, faMagnifyingGlass, faStar } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom"
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { Toaster, toast } from 'react-hot-toast';

function Markets() {
    const { user } = useUser();
    const [assethistory, setAssethistory] = useState([]);
    const [crypto, setCrypto] = useState([]);
    const [fiat, setFiat] = useState([]);
    const [stock, setStock] = useState([]);
    const [favourite, setFavourite] = useState([]);
    const [wallet, setWallet] = useState([]);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchwallet: true })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setWallet(data.wallet);
        }
      })
      .catch(err => {
      })
    }, [user]);
    useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchfavourite: true })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setFavourite(data.favourite);
        }
      })
      .catch(err => {
      })
    }, [user]);
    useEffect(() => {
        fetch(`/coin_list.txt`)
        .then((res) => res.json())
        .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
            id: index + 1,
            logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
            name: coin.name,
            type: 'crypto',
            symbol: coin.symbol,
            price: coin.quote.USD.price,
            amount: 0,
            favourite: 0,
        }));
        setCrypto(updatedData);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {
      fetch(`/stock_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      const stockList = Object.values(data);
      const updatedData = stockList.map((stock, index) => ({
          id: index + 1,
          logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
          name: stock.name,
          type: 'stocks',
          symbol: stock.symbol,
          price: Number(stock.price.toFixed(2)),
          amount: 0,
          favourite: 0,
      }));
      setStock(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    useEffect(() => {   
        fetch(`/fiat_list.txt`)
        .then((res) => res.json())
        .then((data) => {
          const wantedCurrencies = {
            AUD: 'Australian Dollar',
            CAD: 'Canadian Dollar',
            CHF: 'Swiss Franc',
            CNY: 'Chinese Yuan',
            EUR: 'Euro',
            GBP: 'British Pound',
            INR: 'Indian Rupee',
            JPY: 'Japanese Yen',
            RUB: 'Russian Ruble',
            USD: 'US Dollar',
            ZAR: 'South African Rand'
          };
          const fiatList = Object.entries(data)
            .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
            .map(([code, value], index) => ({
              id: index + 1,
              symbol: code,
              name: wantedCurrencies[code],
              price: Number(value),
              type: 'fiat',
              logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
              amount: 0,
              favourite: 0
            }));
          
          setFiat(fiatList);
        })
        .catch((err) => console.error("Error loading coin list:", err));
    }, []);

  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const favSymbols = favourite.map(f => f.symbol);
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = item.balance;
      return acc;
    }, {});
    const enrichAssets = (list) =>
      list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const amount = parseFloat(walletMap[key]) || 0;
        return {
          ...item,
          favourite: favSymbols.includes(item.symbol) ? 1 : 0,
          amount: amount
        };
      });

    const merged = user?.account_type === "Stock" ? [
      ...enrichAssets(stock)
    ] : [
      ...enrichAssets(crypto),
      ...enrichAssets(fiat),
      ...enrichAssets(stock)
    ];

    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      if (b.favourite !== a.favourite) return b.favourite - a.favourite;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock, favourite, wallet]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  
  const filteroptions = user?.account_type === "Stock" ? [
    { value: "all", label: "All Assets" },
    { value: "stock", label: "Stocks Assets" },
  ] : [
    { value: "all", label: "All Assets" },
    { value: "crypto", label: "Crypto Assets" },
    { value: "fiat", label: "Fiat Assets" },
    { value: "stock", label: "Stocks Assets" },
  ];

  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const filteredAssets = assethistory.filter(filteredAsset => 
    Object.values(filteredAsset).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) &&
    (selectedFilter === 'all' || filteredAsset.type.toLowerCase() === selectedFilter.toLowerCase())
  )
  const toggleFavourite = (id) => {
    const targetAsset = assethistory.find(asset => asset.id === id);
    if (!targetAsset) return;
    const updatedFavourite = targetAsset.favourite === 1 ? 0 : 1;
    setAssethistory(prevAssets =>
      prevAssets.map(asset =>
        asset.id === id ? { ...asset, favourite: updatedFavourite } : asset
      )
    );
    fetch(`${process.env.REACT_APP_API_URL}controller/market.controller.php`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updateFavourite: true,
        symbol: targetAsset.symbol,
        favourite: updatedFavourite
      })
    })
    .then(res => res.json())
    .then(data => {
      if (data.status === "success") {
        if (updatedFavourite === 1) {
          toast.success(`${targetAsset.symbol} added to watchlist`);
        } else {
          toast.success(`${targetAsset.symbol} removed from watchlist`);
        }
      } else {
        toast.error("Failed to update favourite");
      }
    })
    .catch(err => {
      toast.error("Error updating favourite");
    });
  };
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div><Toaster/></div>
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Markets" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Markets" icon={<FontAwesomeIcon icon={faChartPie} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '88vh'}}>
                    <div className="d-lg-flex align-items-center justify-content-between mb-4">
                        <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Markets</h6>
                        <div className="d-flex align-items-center mt-2 mt-lg-0">
                            <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                <input 
                                type="text" 
                                placeholder="Search for assets" 
                                className="searchinput"
                                value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <Select 
                                options={filteroptions}
                                value={filteroptions.find((opt) => opt.value === selectedFilter)}
                                onChange={(e) => setSelectedFilter(e.value)}
                                styles={darkThemeStyles}
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div className="table-responsive scrollDown">
                        <table className="table table-hover table-striped table-hover table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                    <th className="fw-normal text-light" style={{minWidth: '200px'}}><FontAwesomeIcon icon={faStar} style={{fontSize: '12px', cursor: 'pointer'}}/> Asset</th>
                                    <th className="fw-normal text-light">Type</th>
                                    <th className="fw-normal text-light text-nowrap">Current price (USD)</th>
                                    <th className="fw-normal text-light text-nowrap">In your wallet</th>
                                    <th className="fw-normal text-light">Actions</th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                            {filteredAssets.length > 0 ? (
                                filteredAssets.map((asset) => (
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center fw-bold" style={{fontSize: '16px'}}>
                                                <FontAwesomeIcon icon={faStar} style={{fontSize: '12px', color: asset.favourite === 1 ?'gold':'lightgray', cursor: 'pointer'}} onClick={() => toggleFavourite(asset.id)} />
                                                <img src={asset.logo} alt={asset.name} style={{width: '20px'}} className="mx-2" />
                                                {asset.name}
                                            </div>
                                        </td>
                                        <td>{asset.type}</td>
                                        <td>{getCurrencySymbol(user?.currency)}{formatCurrency(asset.price * rate)}/{asset.symbol}</td>
                                        <td>{formatCurrency(asset.amount)} {asset.symbol}</td>
                                        <td className="py-3">
                                        <Link to={`/trade?symbol=${asset.symbol}&tradetype=${asset.type}`} className="myBtn" style={{fontSize: '14px', padding: '6px 12px'}}>
                                          Trade
                                        </Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="py-5 text-center" colSpan={7}>You have not gotten an asset yet.</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Markets